module.exports = __webpack_public_path__ + "img/certificate1-04.c7195c21.png";